import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import clsx from 'clsx';
import BaseTypography from '../../Text/BaseTypography';
import { CreateButton, drawerWidth } from '../../UI';
import { CreateChannelButtonProps } from './channelsPageLayoutTypes';
import { Searchbox } from '../../SearchInput/Searchbox';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '100%',
      [theme.breakpoints.up('sm')]: {
        minWidth: drawerWidth,
        borderRight: `1px solid ${theme.palette.divider}`,
        paddingRight: theme.spacing(3.5),
      },
      [theme.breakpoints.down('xs')]: {
        width: '-webkit-fill-available',
        // on mobile screen, hide the left toolbar (channel list)
        // when the secondary sidebar is not mount.
        display: (props: { isSecondarySidebarOpen: boolean }) =>
          props.isSecondarySidebarOpen ? 'flex' : 'none',
      },
    },
    titleWrapper: {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
    },
    actionsWrapper: {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    flexEnd: {
      justifyContent: 'flex-end',
    },
  }),
);

type ChannelsListToolbarProps = {
  pageTitle: string;
  createButtonProps: CreateChannelButtonProps;
  isSecondarySidebarOpen: boolean;
};
export const ChannelsListToolbar: React.FC<ChannelsListToolbarProps> = ({
  pageTitle,
  createButtonProps,
  isSecondarySidebarOpen,
}) => {
  const classes = useStyles({
    isSecondarySidebarOpen,
  });

  const [titleHidden, setTitleHidden] = React.useState(false);

  /**
   * This function is used to toggle the title visibility.
   * When the searchbox is focused, the title should be hidden.
   * When the searchbox is blurred, the title should be shown.
   * We added a delay to the title visibility toggle to text jumping effect
   * when the searchbox is focused.
   */
  const toggleTitle = () => {
    setTimeout(() => {
      setTitleHidden(!titleHidden);
    }, 150);
  };
  return (
    <div
      className={clsx(classes.root, {
        [classes.flexEnd]: titleHidden, // when the searchbox is focused, the container should be flex-end. This will prevent the search box from being pushed to the left when animation is triggered.
      })}
    >
      {!titleHidden && (
        <div className={classes.titleWrapper}>
          <BaseTypography fontType="13Medium">{pageTitle}</BaseTypography>
        </div>
      )}

      <div className={classes.actionsWrapper}>
        <Searchbox
          fullWidthOnFocus
          showIconOnly
          onFocused={toggleTitle}
          onBlurred={toggleTitle}
        />
        {createButtonProps && (
          <CreateButton
            iconOnly
            // the create button is wrapped by a button group. We need to pass the correct color and variant also to
            // the button group to keep the button group style consistent with the create button.
            buttonGroupProps={{
              color: 'secondary',
              variant: 'contained',
            }}
            color="secondary"
            variant="contained"
            {...createButtonProps}
          />
        )}
      </div>
    </div>
  );
};
